import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  setupTitle: {
    id: 'settings.mfa-setup-modal.setupTitle',
    defaultMessage: 'Set up MFA app',
  },
  step1: {
    id: 'settings.mfa-setup-modal.step-1',
    defaultMessage: '1. Download the Google Authenticator app on your mobile device or use an existing MFA app',
  },
  step2: {
    id: 'settings.mfa-setup-modal.step-2',
    defaultMessage: '2. Scan this QR code',
  },
  step3: {
    id: 'settings.mfa-setup-modal.step-3',
    defaultMessage: '3. Enter the 6-digit code generated by the app to verify and complete setup',
  },
  infoText: {
    id: 'settings.mfa-setup-modal.info-text',
    defaultMessage:
      'Use your mobile MFA app to scan this QR code, or enter the key below into your MFA app (such as Google Authenticator, Authy, or other).',
  },
  copiedToClipboard: {
    id: 'settings.mfa-setup-modal.copied-to-clipboard',
    defaultMessage: 'Secret key copied to clipboard',
  },
  copiedToClipboardError: {
    id: 'settings.mfa-setup-modal.copied-to-clipboard-error',
    defaultMessage: 'Failed to copy secret key to clipboard',
  },
  keyTypeInfo: {
    id: 'settings.mfa-setup-modal.key-type-info',
    defaultMessage: 'Key type: Time-based',
  },
  continue: {
    id: 'settings.mfa-setup-modal.continue',
    defaultMessage: 'Continue',
  },
  enterCodeLabel: {
    id: 'settings.mfa-setup-modal.enter-code-label',
    defaultMessage: 'Enter the code generated by your MFA app.',
  },
  completeSetupTitle: {
    id: 'settings.mfa-setup-modal.complete-setup-title',
    defaultMessage: 'Complete setup',
  },
  errorValidateOTP: {
    id: 'settings.mfa-setup-modal.error-validate-otp',
    defaultMessage: 'There was an error validating the OTP code. Please try again.',
  },
  errorOTPExpired: {
    id: 'settings.mfa-setup-modal.error-otp-expired',
    defaultMessage: 'MFA verification period has expired. Please restart the setup process.',
  },
  codeNotValid: {
    id: 'settings.mfa-setup-modal.code-not-valid',
    defaultMessage: 'Code is not valid',
  },
  setupSuccessful: {
    id: 'settings.mfa-setup-modal.setup-successful',
    defaultMessage: 'MFA setup successful!',
  },
  validationExpiredTitle: {
    id: 'settings.mfa-setup-modal.validation-expired-title',
    defaultMessage: 'Setup has failed',
  },
  validationExpiredSubtitle: {
    id: 'settings.mfa-setup-modal.validation-expired-subtitle',
    defaultMessage: 'You’ve taken too long to complete the MFA setup, click below to try again.',
  },
  enableMFAButton: {
    id: 'settings.mfa-setup-modal.enable-mfa-button',
    defaultMessage: 'Enable MFA',
  },
  mfaActiveTitle: {
    id: 'settings.mfa-setup-modal.mfa-active-title',
    defaultMessage: 'MFA is now active',
  },
  mfaActiveSubtitle: {
    id: 'settings.mfa-setup-modal.mfa-active-subtitle',
    defaultMessage: 'You’ll need to use your MFA app to verify your identity next time you log in.',
  },
  saveCodesTitle: {
    id: 'settings.mfa-setup-modal.save-codes-title',
    defaultMessage: 'Save your backup codes - Recommended',
  },
  recoveryCodesTitle: {
    id: 'settings.mfa-setup-modal.recovery-codes-title',
    defaultMessage: 'Your new recovery codes',
  },
  saveCodesSubtitle: {
    id: 'settings.mfa-setup-modal.save-codes-subtitle',
    defaultMessage: 'You will need these codes for logging in if you can’t access your MFA app.',
  },
  saveCodesPrintInfo: {
    id: 'settings.mfa-setup-modal.save-codes-print-info',
    defaultMessage: 'Print or copy and keep these backup codes somewhere safe.',
  },
  printButton: {
    id: 'settings.mfa-setup-modal.print-button',
    defaultMessage: 'Print',
  },
  copyCodesButton: {
    id: 'settings.mfa-setup-modal.copy-codes-button',
    defaultMessage: 'Copy codes',
  },
  closeButton: {
    id: 'settings.mfa-setup-modal.close-button',
    defaultMessage: 'Close',
  },
  codesCopiedToClipboard: {
    id: 'settings.mfa-setup-modal.codes-copied-to-clipboard',
    defaultMessage: 'Backup codes copied to clipboard',
  },
  codesCopiedToClipboardError: {
    id: 'settings.mfa-setup-modal.codes-copied-to-clipboard-error',
    defaultMessage: 'Failed to copy backup codes to clipboard',
  },
});
